import { defineStore } from "pinia";
import { ref } from "vue";

export const useInstruccionStore = defineStore("instrucciones", () => {
  const instrucciones = ref([
    { id: "primaria", nombre: "Primaria" },
    { id: "secundaria", nombre: "Secundaria" },
    { id: "terciaria", nombre: "Terciaria" },
    { id: "universitaria", nombre: "Universitaria" },
    { id: "no_sabe_leer_no_sabe_firmar", nombre: "No sabe leer, no sabe firmar" },
    { id: "no_sabe_leer_sabe_firmar", nombre: "No sabe leer, si sabe firmar" },
    { id: "sabe_leer_sabe_firmar", nombre: "Sabe leer y sabe firmar" },
  ]);

  const getAll = () => instrucciones.value;

  const getByNombre = (nombre) => {
    if (!nombre) return null;

    const instruccion = instrucciones.value.find(
      (n) => n.nombre.toUpperCase() === nombre.toUpperCase()
    );

    return instruccion ? instruccion.id : null;
  };

  return {
    instrucciones,
    getAll,
    getByNombre,
  };
});
